(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-daily-selection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-daily-selection')) {
    class DmDailySelection extends HTMLElement {
      connectedCallback() {
        clearInterval(this.dailyInterval);
        const source = this.querySelector('[data-dm-daily-products]');
        this.dailyProducts = source ? Array.from(source.content.querySelectorAll('a')).map(link => ({ title: link.textContent.trim(), url: link.getAttribute('href') })) : [];
        this.dailyLink = this.querySelector('[data-dm-daily-link]');
        this.dailyClock = this.querySelector('[data-dm-daily-clock]');
        this.dailyTime = this.querySelector('[data-dm-daily-time]');
        if (this.dailyProducts.length < 2 || !this.dailyLink || !this.dailyClock || !this.dailyTime) return;
        this.chileDateFormatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit'
        });
        this.updateDailySelection();
        this.dailyInterval = setInterval(() => this.updateDailySelection(), 1000);
      }
      disconnectedCallback() { clearInterval(this.dailyInterval); }
      chileDay(timestamp) {
        const parts = Object.fromEntries(this.chileDateFormatter.formatToParts(timestamp).map(part => [part.type, part.value]));
        return Math.floor(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000);
      }
      updateDailySelection() {
        const now = Date.now();
        const day = this.chileDay(now);
        if (this.dailyDate !== day) {
          let start = now;
          let end = now + 27 * 60 * 60 * 1000;
          while (end - start > 1) {
            const middle = Math.floor((start + end) / 2);
            if (this.chileDay(middle) === day) start = middle;
            else end = middle;
          }
          this.dailyDeadline = end;
          this.dailyDate = day;
        }
        const index = ((day % this.dailyProducts.length) + this.dailyProducts.length) % this.dailyProducts.length;
        const item = this.dailyProducts[index];
        if (this.dailyIndex !== index) {
          this.dailyLink.textContent = item.title + ' →';
          this.dailyLink.setAttribute('href', item.url);
          this.dailyIndex = index;
        }
        const seconds = Math.max(0, Math.ceil((this.dailyDeadline - now) / 1000));
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        this.dailyTime.textContent = [hours, minutes, remainingSeconds].map(value => String(value).padStart(2, '0')).join(':');
        this.dailyClock.hidden = false;
      }
    }
    customElements.define('dm-daily-selection', DmDailySelection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-product-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-return-to-buy')) {
    customElements.define('dm-return-to-buy', class extends HTMLElement {
      connectedCallback() {
        const anchor = document.querySelector('[data-dm-purchase-anchor]');
        const submit = document.querySelector('product-info .product-form__submit');
        const footer = document.querySelector('.dm-footer');
        if (!anchor || !submit || !('IntersectionObserver' in window)) return;
        this.passed = false;
        this.atFooter = false;
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === submit) this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === footer) this.atFooter = entry.isIntersecting;
          }
          this.hidden = !this.passed || this.atFooter;
        });
        this.observer.observe(submit);
        if (footer) this.observer.observe(footer);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-promo-bar"]) return;
  try {
    
  if (!customElements.get('dm-promo-bar')) {
    class DmPromoBar extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.dm-promo__toggle');
        if (!this.toggle || this.hasAttribute('data-ready')) return;
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        };
        this.toggle.addEventListener('click', this.onToggle);
        this.toggle.hidden = false;
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.removeAttribute('data-ready');
      }
    }
    customElements.define('dm-promo-bar', DmPromoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
